import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Block from "@store/Components/Common/Block/Block";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import * as React from "react";

const CategoryMainImage = getWidgetComponent("Category/CategoryMainImage");
const CategoryDetailsSubCategoriesList = getWidgetComponent("Category/CategoryDetailsSubCategoriesList");
const SecondLevelCategoryDetailsSubCategoriesList = getWidgetComponent("Category/SecondLevelCategoryDetailsSubCategoriesList");

const enum fields {
    categoryLevel = "categoryLevel",
    hideBanner = "hideBanner",
    showAnchorMenu = "showAnchorMenu"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.categoryLevel]:             
        | "firstLevel"
        | "secondLevel"
        | "thirdLevel";
        [fields.hideBanner]: boolean;
        [fields.showAnchorMenu]: boolean;
    };
}

type Props = OwnProps & HasCategoryContext;

const CategoryDetailView: React.FunctionComponent<Props> = (props: Props) => {
    const { category, fields, id } = props;

    if (!category) {
        return null;
    }

	return (
        <Block>
            <CategoryMainImage showTitle showBanner={!fields.hideBanner} />
            <Zone contentId={id} zoneName="CustomContent" />
            {fields.categoryLevel === "secondLevel" && !category.id.includes(":") ? (
                <SecondLevelCategoryDetailsSubCategoriesList showImages showAnchorMenu={fields.showAnchorMenu} />
            ) : (
                <CategoryDetailsSubCategoriesList showImages />
            )}
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailView),
    definition: {
        group: "Categories",
        displayName: "Category Page View",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.categoryLevel,
                displayName: "Category Level Is",
                editorTemplate: "DropDownField",
                fieldType: "General",
                sortOrder: 1,
                options: [
                    { displayName: "1", value: "firstLevel" },
                    { displayName: "2", value: "secondLevel" },
                    { displayName: "3", value: "thirdLevel" },
                ],
                defaultValue: "secondLevel",
            },
            {
                name: fields.hideBanner,
                displayName: "Hide Banner",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.showAnchorMenu,
                displayName: "Show Anchor Menu",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
                isVisible: widget => widget.fields.categoryLevel === "secondLevel",
            },
        ],
    },
};

export default widgetModule;
